import { faEye } from "@fortawesome/free-solid-svg-icons";

const columnsMaintenances = [
  { key: "maintenance_date", label: "Data da Manutenção" },
  { key: "maintenance_status", label: "Status da Manutenção" },
  { key: "maintenance_type", label: "Tipo de Manutenção" },
  { key: "maintenance_details", label: "Motivo da Manutenção" },
  { key: "technician", label: "Técnico" },
  { key: "technician_status", label: "Situação" },
];

const collapseConfigMaintenances = {
  key: ["items"],
  titles: ["Serviços da manutenção"],
  totalField: [],
  columns: [
    [
      { key: "items.id", label: "ID do Serviço" },
      { key: "items.service_date", label: "Data do Serviço" },
      { key: "items.technician_status", label: "Situação do Técnico" },
      { key: "items.details", label: "Detalhes do Serviço" },
    ],
  ],
};

const actionsMaintenances = (navigate, canAccess) => [
  {
    id: "details",
    icon: faEye,
    title: "Ver Detalhes da Manutenção",
    buttonClass: "btn-info",
    permission: "Ver manutenções",
    onClick: (maintenance) =>
      navigate(`/manutencao/detalhes/${maintenance.id}`),
    show: (maintenance) =>
      !maintenance.isDeleted && canAccess("Ver manutenções"),
  },
];

export { columnsMaintenances, actionsMaintenances, collapseConfigMaintenances };
